import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "../components/button";
import img from "../assets/icon/coolicon.png";
import {
  ComponentTabLink,
  ITabLink,
  ITabTitle,
  PageType,
} from "../components/component-tab";
import remove from "../assets/icon/exit.png";
import { FormError2 } from "../components/form-error";
import { ICrProjectFormProps, useCrProject } from "../hooks/useCrProject";
import { AsideAdminComponent } from "../layout/aside-admin";
import { usePrompt } from "../constants/function";
import {
  CrMainCategoryInput,
  CrMainCategoryMutation,
} from "../generated/graphql";
import { upload } from "../functions/uploads";
import {
  ICrMainCategoryFormProps,
  useCrMainCategory,
} from "../hooks/useCrMainCategory";
import { useNavigate } from "react-router-dom";

export const AdminCrCategory = () => {
  const navigate = useNavigate();
  const [uploadUuid, setUploadUuid] = useState<string>("");
  // 1. (추가) 이미지 미리보기 URL을 저장할 state
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string>("");
  const [uploading, setUploading] = useState<boolean>(false);

  const {
    getValues,
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<ICrMainCategoryFormProps>({ mode: "all" });

  const onComplete = async (data: CrMainCategoryMutation) => {
    const {
      crMainCategory: { ok, err },
    } = data;
    if (ok) {
      alert("카테고리 등록");
      window.location.href = `/category`;
    } else {
      alert(err);
    }
  };
  const [crMainCategory, { loading }] = useCrMainCategory(onComplete);

  const onSubmit = () => {
    if (!loading) {
      const { name } = getValues();
      const crMainCategoryInput: CrMainCategoryInput = {
        name,
        imageUuid: uploadUuid,
      };
      crMainCategory({ variables: { input: crMainCategoryInput } });
    }
  };

  const tabList: ITabLink[] = [];
  const stitle: ITabTitle = { text: "프로젝트 등록" };

  // 2. (변경) 파일 선택 시 미리보기 URL을 생성하고 state를 업데이트하는 로직 추가
  const uploadPosterHandler = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (uploading) {
      alert("파일을 업로드 중입니다.");
      return;
    }

    // 선택된 파일로 미리보기 URL 생성
    const previewUrl = URL.createObjectURL(file);
    setImagePreviewUrl(previewUrl);

    // 기존 파일 업로드 로직
    const result = await upload(event);

    if (result.data.ok) {
      setUploadUuid(result.data.upload.uuid);
    } else {
      alert(`잘못된 파일`);
      // 업로드 실패 시 미리보기 이미지 제거
      setImagePreviewUrl("");
      URL.revokeObjectURL(previewUrl); // 메모리 누수 방지
    }
  };

  return (
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen bg-gray-100">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr] max-w-full">
            <AsideAdminComponent />
            <div className="mypages bg-gray-100 w-full min-w-[1200px] overflow-hidden">
              <div className="orderWrap">
                <div className="h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink
                      tabs={tabList}
                      stitle={stitle}
                      type={PageType.Create}
                    />
                    <div className="shadow-lg w-full h-fix-content bg-white">
                      <form onSubmit={handleSubmit(onSubmit)} id="create">
                        <div className="pl-9 pr-11 py-8 space-y-4">
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              이름
                            </p>
                            <input
                              {...register("name", {
                                required: `이름을 입력해주세요`,
                              })}
                              type="text"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            />
                            {errors.name?.message && (
                              <FormError2 errorMessage={errors.name.message} />
                            )}
                          </div>
                          <div className="flex flex-wrap gap-4">
                            <div
                              key={`thumbnail-${uploadUuid}`}
                              className="w-24 aspect-square border rounded-lg border-[#000000] relative"
                            >
                              <button
                                className={`absolute -top-2 -right-2 bg-black rounded-full z-10`}
                                onClick={() => {
                                  setUploadUuid("");
                                  setImagePreviewUrl("");
                                }}
                              >
                                <img src={remove} alt={`이 이미지 없애기`} />
                              </button>
                              <label
                                htmlFor={`poster`}
                                className="flex flex-wrap w-full h-full content-center justify-center cursor-pointer"
                              >
                                {!imagePreviewUrl && <img src={img} alt="이미지 업로드 아이콘" />}       
                                <img
                                  src={imagePreviewUrl} // src를 state의 미리보기 URL로 설정
                                  alt="썸네일"
                                  className={`absolute left-0 top-0 w-full h-full rounded-lg object-cover ${
                                    !imagePreviewUrl ? "hidden" : "" // 미리보기 URL이 없으면 숨김
                                  } `}
                                />
                              </label>
                              <input
                                type="file"
                                className="hidden"
                                id={`poster`}
                                accept="image/png, image/jpeg, image/jpg, image/gif"
                                onChange={uploadPosterHandler}
                              ></input>
                            </div>
                          </div>
                          <div className="flex flex-wrap justify-center pt-6">
                            <Button
                              className={`w-[240px] h-[40px] bg-[#3D3E49] text-white rounded-lg`}
                              canClick={true}
                              actionText={`등록`}
                              loading={loading}
                              color={"text-white"}
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};